<template>
  <nuxt-link :to="linkToArticle" class="text-white text-decoration-none">
    <p v-if="article.category !== 'None'" class="text-uppercase">
      <strong>{{ article.category }}</strong>
    </p>
    <div class="row justify-content-between align-items-center">
      <div class="col-10 col-xl-9">
        <h3 class="mb-0 text-uppercase">{{ article.title }}</h3>
      </div>
      <div class="col-2 col-xl-3">
        <fa-icon :icon="faCircleArrowRight" class="fs-2 text-primary" />
      </div>
    </div>
    <p class="mb-0">{{ publishedAt }}</p>
  </nuxt-link>
</template>

<script lang="ts">
import { faCircleArrowRight } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiArticle } from '~/apollo/types/types';
import {
  useArticleLink,
  useArticlePublishedDate,
} from '../../features/useArticleFeatures';

export default defineComponent({
  props: {
    article: {
      type: Object as PropType<StrapiArticle>,
      required: true,
    },
  },
  setup(props) {
    const article = toRef(props, 'article');

    const { publishedAt } = useArticlePublishedDate(article, 'long');
    const { linkToArticle } = useArticleLink(article);

    return {
      faCircleArrowRight,

      linkToArticle,
      publishedAt,
    };
  },
});
</script>

<style scoped></style>
